var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.name === null)?_c('em',[_vm._v("Loading User Name...")]):(_vm.normal)?_c('span',[_vm._v(_vm._s(_vm.name))]):_c('strong',[_vm._v(_vm._s(_vm.name))])}
var staticRenderFns = []

export { render, staticRenderFns }